import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'
import { LoggedInUserAccessDetails } from '../models/loggedInUserModel';


@Injectable({ providedIn: 'root' })
export class AuthService {

  Authorization$ = new BehaviorSubject<string>('');
  IsAdminUser$ = new BehaviorSubject<boolean>(false);
  IsTenantUser$ = new BehaviorSubject<boolean>(false);
  IsMerchantUser$ = new BehaviorSubject<boolean>(false);
  AccessDetails$ = new BehaviorSubject<LoggedInUserAccessDetails>({} as any);
  hostName$ = new BehaviorSubject<string>('');
  Session$ = new BehaviorSubject<string>('');
  UserName$ = new BehaviorSubject<string>('');
  loginHostName$ = new BehaviorSubject<string>('');
  stage$ = new BehaviorSubject<string>('');
  tenantId$ = new BehaviorSubject<string>('');
  constructor() {
  }


}
